export enum UsageIntent {
  Attribution = 'Attribution',
  Retargeting = 'Retargeting',
}
